export default "__VITE_ASSET__BTGmivlW__"